import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export class Carousel {
  el: HTMLElement
  swiper: Swiper

  constructor(el) {
    this.el = el
    this.init()
  }

  init() {
    this.swiper = new Swiper(this.el, {
      modules: [ Autoplay ],
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      speed: 1000,
      slidesPerView: "auto",
      spaceBetween: 32,
      slidesPerGroup: 1,
      centeredSlides: true,
      loop: true,
      loopAdditionalSlides: 2,
      allowTouchMove: false
    })
  }
}